import { useCallback } from "react";
import useFeature from "hooks/useFeature";
import useRightSidebar from "hooks/useRightSidebar";
import { useModalContext } from "common/contexts";
function useAssetPanel() {
  const isRightSidebarEnabled = useFeature("asset_right_sidebar");
  const { openSidebar, closeSidebar } = useRightSidebar();
  const { setModal, setEntity } = useModalContext();
  const openAssetDetails = useCallback(
    (asset) => {
      if (isRightSidebarEnabled) {
        openSidebar({
          id: `asset-${asset.id}`,
          title: `${asset.name} Details`,
          componentKey: "AssetSidebarContent",
          props: { assetId: asset.id }
        });
      } else {
        setEntity({ asset });
        setModal("ASSET-DETAILS");
      }
    },
    [isRightSidebarEnabled, openSidebar, setModal, setEntity]
  );
  const closeAssetDetails = useCallback(() => {
    if (isRightSidebarEnabled) {
      closeSidebar();
    } else {
      setModal(null);
      setEntity(null);
    }
  }, [isRightSidebarEnabled, closeSidebar, setModal, setEntity]);
  return {
    openAssetDetails,
    closeAssetDetails
  };
}
export default useAssetPanel;
